import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { ApiRequest, IAppState } from "../../Common";
import { BugReport, FeatureRequest, ResourceRequest } from "../Models/Feedback";
import { FeedbackCategory } from "../Constants/feedbackEnums";
import { endpoints } from "..";
import { ResponseResult } from "../../Common/Models/ResponseResult";
import ResponseHandler from "../../App/ResponseHandler";

export interface ActionBase {
  type: FeedbackDetailsActionType;
}

export interface Action<Payload> extends ActionBase {
  payload: Payload | null;
}

export enum FeedbackDetailsActionType {
  SET_FEEDBACK_DETAILS = "FEEDBACK_VIEW_SET_FEEDBACK_DETAILS",
  RESET_LOADING = "FEEDBACK_VIEW_RESET_LOADING",
  SET_LOADING = "FEEDBACK_VIEW_SET_LOADING",
  UPDATE_LOADED_FEEDBACK_DETAILS = "FEEDBACK_VIEW_UPDATE_LOADED_FEEDBACK",
  RESET_LOADED = "FEEDBACK_VIEW_RESET_LOADED",
  SET_ERROR = "FEEDBACK_VIEW_SET_ERROR"
}

const setFeedbackDetails = (
  feedback: FeatureRequest | BugReport | ResourceRequest | null
): Action<FeatureRequest | BugReport | ResourceRequest | null> => {
  return {
    type: FeedbackDetailsActionType.SET_FEEDBACK_DETAILS,
    payload: feedback
  };
};

export const setLoading = (): ActionBase => {
  return {
    type: FeedbackDetailsActionType.SET_LOADING
  };
};

export const resetLoading = (): ActionBase => {
  return {
    type: FeedbackDetailsActionType.RESET_LOADING
  };
};

export const resetLoaded = (): ActionBase => {
  return {
    type: FeedbackDetailsActionType.RESET_LOADED
  };
};

export const updateLoadedFeedback = (
  feedback: FeatureRequest | BugReport | ResourceRequest
): Action<FeatureRequest | BugReport | ResourceRequest> => {
  return {
    type: FeedbackDetailsActionType.UPDATE_LOADED_FEEDBACK_DETAILS,
    payload: feedback
  };
};

const setError = (status: number, description: string) => {
  return {
    type: FeedbackDetailsActionType.SET_ERROR,
    payload: {
      errorCode: status,
      errorDescription: description
    }
  };
};

export const getFeedbackDetails = (
  code: string
): ThunkAction<Promise<void>, IAppState, {}, Action<any>> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<any> => {
    ApiRequest.fromPath(endpoints.feedback.getByCode(code))
      .withAuthHeader()
      .get()
      .then((response: Response) => {
        ResponseHandler.handle(
          response,
          (result: ResponseResult) => {
            const category =
              FeedbackCategory[result.payload.category as keyof typeof FeedbackCategory];

            if (category === FeedbackCategory.FeatureRequest) {
              dispatch(setFeedbackDetails(result.payload as FeatureRequest));
            } else if (category === FeedbackCategory.BugReport) {
              dispatch(setFeedbackDetails(result.payload as BugReport));
            } else if (category === FeedbackCategory.ResourceRequest) {
              dispatch(setFeedbackDetails(result.payload as ResourceRequest));
            }
          },
          (result: ResponseResult) => {
            dispatch(setError(response.status, result.error.message));
          },
          () => {
            dispatch(setError(response.status, "An unknown error has occured"));
          }
        );
      });
  };
};
